import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6b19451b&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=6b19451b&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=6b19451b&prod&lang=scss&scoped=true"
import style2 from "./List.vue?vue&type=style&index=2&id=6b19451b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19451b",
  null
  
)

export default component.exports